<template>
    <div class="request-loading">
        <LightBox :show="show">
            <CenterBox :show="show">
                <Loading :show="show"></Loading>
            </CenterBox>
        </LightBox>
    </div>
</template>

<script>
    import CenterBox from '@/components/tool/CenterBox';
    import Loading from '@/components/tool/Loading';
    import LightBox from '@/components/tool/LightBox';

    export default {
        name: "RequestLoading",
        components: {
            CenterBox,
            Loading,
            LightBox
        },
        props: {
            show: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>